import { createContext } from 'react';
import { Hackathon } from '../../Api';

type HackathonProps = { hackathonId: number; hackathon: Hackathon | null };
export const HackathonContext = createContext<HackathonProps>({} as HackathonProps);
